import { useMemo } from 'react';
import { Box, HStack } from '@cbhq/cds-web/layout';
import { Table, TableBody, TableCell, TableHeader, TableRow } from '@cbhq/cds-web/tables';
import { TextBody } from '@cbhq/cds-web/typography';

import { BaseL3Chain } from ':cloud/types/ts_types';

import { ClipboardIcon } from '../sharedcomponents';

type BaseL3DetailsProps = {
  chain: BaseL3Chain;
  isDeploying: boolean;
};

export function BaseL3Details({ chain, isDeploying }: BaseL3DetailsProps) {
  const formattedTokenAddress = useMemo(() => {
    const token = chain?.customizations?.customGasToken || '';
    return `${token.slice(0, 4)}...${token.slice(-4)}`;
  }, [chain?.customizations?.customGasToken]);

  return (
    <Box maxWidth={isDeploying ? '400px' : ''} spacingBottom={5} spacingHorizontal={3}>
      <Table>
        <TableHeader>
          <TableRow>
            {!isDeploying && (
              <TableCell color="foreground" width="15%">
                Slug
              </TableCell>
            )}
            {!isDeploying && (
              <TableCell color="foreground" width="15%">
                Chain ID
              </TableCell>
            )}
            <TableCell color="foreground" width={isDeploying ? '50%' : '15%'}>
              Gas token
            </TableCell>
            <TableCell color="foreground" width={isDeploying ? '50%' : '15%'}>
              Data availability
            </TableCell>
            {!isDeploying && (
              <TableCell color="foreground" width="15%">
                Withdrawal period
              </TableCell>
            )}
            {!isDeploying && (
              <TableCell color="foreground" width="15%">
                Gas block limit
              </TableCell>
            )}
          </TableRow>
        </TableHeader>
        <TableBody>
          <TableRow>
            {!isDeploying && (
              <TableCell width="15%">
                <HStack alignItems="center" gap={1}>
                  <TextBody as="p" color="foregroundMuted">
                    {chain?.name}
                  </TextBody>
                  <ClipboardIcon text={chain.name} iconSize="s" />
                </HStack>
              </TableCell>
            )}
            {!isDeploying && (
              <TableCell width="15%">
                <HStack alignItems="center" gap={1}>
                  <TextBody as="p" color="foregroundMuted">
                    {chain?.id || '--'}
                  </TextBody>
                  {!!chain?.id && <ClipboardIcon text={chain?.id?.toString()} iconSize="s" />}
                </HStack>
              </TableCell>
            )}
            <TableCell width={isDeploying ? '50%' : '15%'}>
              <HStack alignItems="center" gap={1}>
                <TextBody as="p" color="foregroundMuted">
                  {chain?.customizations?.customGasToken ? formattedTokenAddress : '--'}
                </TextBody>
                {chain?.customizations?.customGasToken && (
                  <ClipboardIcon
                    text={chain?.customizations?.customGasToken || '--'}
                    iconSize="s"
                  />
                )}
              </HStack>
            </TableCell>
            <TableCell color="foregroundMuted" width={isDeploying ? '50%' : '15%'}>
              {chain?.customizations?.dataAvailability || '--'}
            </TableCell>
            {!isDeploying && (
              <TableCell width="15%">
                <HStack alignItems="center" gap={1}>
                  <TextBody color="foregroundMuted" as="p">
                    {chain?.customizations?.withdrawPeriod || '--'}
                  </TextBody>
                  <ClipboardIcon
                    text={chain?.customizations?.withdrawPeriod || '--'}
                    iconSize="s"
                  />
                </HStack>
              </TableCell>
            )}
            {!isDeploying && (
              <TableCell width="15%">
                <HStack alignItems="center" gap={1}>
                  <TextBody color="foregroundMuted" as="p">
                    {chain?.customizations?.blockGasLimit || '--'}
                  </TextBody>
                  <ClipboardIcon text={chain?.customizations?.blockGasLimit || '--'} iconSize="s" />
                </HStack>
              </TableCell>
            )}
          </TableRow>
        </TableBody>
      </Table>
    </Box>
  );
}
